// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__t0fXG","content":"styles_content__2r04C","checkbox":"styles_checkbox__qEqH2","checkboxLabel":"styles_checkboxLabel__1XTgS"};